import firebase from 'firebase/app';
import 'firebase/auth';
import { currentUser, isAuthGuardActive } from '../../constants/config';
import { setCurrentUser, getCurrentUser } from '../../utils';
import axios from "axios";
// axios.defaults.headers.common["Authorization"] =
//   "Bearer " + localStorage.getItem("token_admin");
import router from "../../router";

export default {
  state: {
    currentUser: isAuthGuardActive ? getCurrentUser() : currentUser,
    loginError: null,
    processing: false,
    forgotMailSuccess: null,
    resetPasswordSuccess: null
  },
  getters: {
    currentUser: state => state.currentUser,
    processing: state => state.processing,
    loginError: state => state.loginError,
    forgotMailSuccess: state => state.forgotMailSuccess,
    resetPasswordSuccess: state => state.resetPasswordSuccess,
  },
  mutations: {
    setUser(state, payload) {
      state.currentUser = payload;
      state.processing = false;
      state.loginError = null;
    },
    setLogout(state) {
      state.currentUser = null;
      state.processing = false;
      state.loginError = null;
    },
    setProcessing(state, payload) {
      state.processing = payload;
      state.loginError = null;
    },
    setError(state, payload) {
      state.loginError = payload;
      state.currentUser = null;
      state.processing = false;
    },
    setForgotMailSuccess(state) {
      state.loginError = null;
      state.currentUser = null;
      state.processing = false;
      state.forgotMailSuccess = true;
    },
    setResetPasswordSuccess(state) {
      state.loginError = null;
      state.currentUser = null;
      state.processing = false;
      state.resetPasswordSuccess = true;
    },
    clearError(state) {
      state.loginError = null;
    }
  },
  actions: {
    async login({ commit }) {
      let provider = new firebase.auth.GoogleAuthProvider();

      commit('clearError');
      commit('setProcessing', true);

      firebase.auth().languageCode = 'es';

      firebase
        .auth()
        .signInWithPopup(provider)
        .then(
          async user => {

            try {
                const idToken = await user.user.getIdToken(true);

                const accessData = {
                    accessToken: idToken,
                    email: user.additionalUserInfo.profile.email
                }
              let usuario = await axios.post(`${process.env.VUE_APP_HOST}/api/dashboard/admin/login`, accessData);
              console.log('Success:', usuario.data.success);
              if (usuario.data.success) {

                const item = {
                  uid: user.user.uid,
                  title: user.additionalUserInfo.profile.name,
                  img: user.additionalUserInfo.profile.picture,
                  email: user.additionalUserInfo.profile.email,
                  role: usuario.data.role,
                  token: usuario.data.token
                };

                localStorage.setItem('token_admin', usuario.data.token);

                setCurrentUser(item);
                commit('setUser', item);

              } else {
                console.log('error');
                setCurrentUser(null);
                commit('setError', 'Usted no cuenta con acceso a la plataforma.');

                setTimeout(() => {
                  commit('clearError');
                }, 3000);
              }
            } catch (error) {
              console.error(error)
              if (error.response && error.response.status === 500) {
                commit('setError', 'Error interno del servidor. Por favor, inténtelo de nuevo más tarde.');
              } else {
                commit('setError', 'El correo electrónico no se encuentra registrado en la plataforma.');
              }
              setCurrentUser(null);
              setTimeout(() => {
                commit('clearError');
              }, 3000);
            }

            // let usuario = await axios.post(`${process.env.VUE_APP_HOST}/api/dashboard/admin/login`, { email: user.additionalUserInfo.profile.email });
            // console.log('usuario:', usuario)
            // if (usuario.data.success) {

            //   const item = {
            //     uid: user.user.uid,
            //     title: user.additionalUserInfo.profile.name,
            //     img: user.additionalUserInfo.profile.picture,
            //     email: user.additionalUserInfo.profile.email,
            //     role: usuario.data.role,
            //     token: usuario.data.token
            //   };

            //   localStorage.setItem('token_admin', usuario.data.token);

            //   setCurrentUser(item);
            //   commit('setUser', item);

            // } else {
            //   console.log('error');
            //   setCurrentUser(null);
            //   commit('setError', 'Usted no cuenta con acceso a la plataforma.');

            //   setTimeout(() => {
            //     commit('clearError');
            //   }, 3000);

            // }
          },
          err => {
            setCurrentUser(null);
            commit('setError', err.message);
            setTimeout(() => {
              commit('clearError')
            }, 3000)
          }

        )
    },
    /*forgotPassword({ commit }, payload) {
      commit('clearError')
      commit('setProcessing', true)
      firebase
        .auth()
        .sendPasswordResetEmail(payload.email)
        .then(
          user => {
            commit('clearError')
            commit('setForgotMailSuccess')
          },
          err => {
            commit('setError', err.message)
            setTimeout(() => {
              commit('clearError')
            }, 3000)
          }
        )
    },
    resetPassword({ commit }, payload) {
      commit('clearError')
      commit('setProcessing', true)
      firebase
        .auth()
        .confirmPasswordReset(payload.resetPasswordCode, payload.newPassword)
        .then(
          user => {
            commit('clearError')
            commit('setResetPasswordSuccess')
          },
          err => {
            commit('setError', err.message)
            setTimeout(() => {
              commit('clearError')
            }, 3000)
          }
        )
    },*/


    signOut({ commit }) {
      firebase
        .auth()
        .signOut()
        .then(() => {
          setCurrentUser(null);
          localStorage.removeItem('token_admin');
          commit('setLogout')
        }, _error => console.log('error', _error))
    }
  }
}
